import React from 'react';
import { Link } from "react-router-dom";

import "../styles/About.css";

let isIE = /*@cc_on!@*/false || !!document.documentMode;

var About = () => (
  <div className="about">
  <img className="background" src={require("../assets/bg-image-home.jpg")} alt="Background" />
  <img className="header" src={require("../assets/header-footer-colours.jpg")} alt="Header" />
    <h1 className="pageTitle">About Power Quiz</h1>
    <img className="pqLogo" src={require("../assets/power-quiz-logo.png")} alt="Power Quiz Logo" />
    <img className="asLogo" src={require("../assets/ageScotlandLogo.png")} alt="ageScotland Logo" />
    <div className="intro">
      <p><strong>Power Quiz</strong> is a resource to support regular physical exercise by older adults with a focus on improving strength and balance. It’s ideal for group settings, with participants in two or more teams. A quiz master pack can be requested from Age Scotland: email <a href="mailto:healthandwellbeing@agescotland.org.uk">healthandwellbeing@agescotland.org.uk</a> or call on 0333 323 2400. Power Quiz provides four ready-made quizzes to get you started.  After that, you can have fun making up your own quizzes and use the My Quiz option to play the exercise videos for answers in each of your four rounds.</p>
    </div>
    <div className="strengthAndBalance">
      <h3>About Strength and Balance</h3>
      <p>Adults gradually lose bone density and muscle strength as they get older. However regular strength and balance exercise help to maintain bone density and muscles. These should be undertaken for at least ten minutes, three times a week, and every week. Public health guidance also recommends breaking up long periods of sitting and doing half an hour of moderate physical activity five days each week.</p>
    </div>
    <Link className="begin button" to="/howtoplay">Next</Link>
    <div className="misc">
      <i>Power Quiz® development and video demonstrations: Doug Anthoney and Rachel Connor | Music: Doug Anthoney © Age Scotland 2020 | Exercises consultancy Yolanda Strachan and Jenny Ackland | Age Scotland is grateful to the Armed Forces Covenant Fund Trust and Unforgotten Forces partnership for funding support for Power Quiz®</i>
    </div>
    <img className="footer" src={require("../assets/header-footer-colours.jpg")} alt="Footer" />
  </div>
);

if(isIE){
  About = () => (
    <div className="ie-about">
      <div className="header-footer">
        <img className="header" src={require("../assets/header-footer-colours.jpg")} alt="Header" />
      </div>
      <div className="pageContent">
        <div className="heading">
          <h1>About Power Quiz</h1>
          <div className="logos">
            <img className="pqLogo" src={require("../assets/power-quiz-logo.png")} alt="Power Quiz Logo" />
            <img className="asLogo" src={require("../assets/ageScotlandLogo.png")} alt="ageScotland Logo" />
          </div>
        </div>
        <p className="intro"><strong>Power Quiz</strong> is a resource to support regular physical exercise by older adults with a focus on improving strength and balance. It’s ideal for group settings, with participants in two or more teams. A quiz master pack can be requested from Age Scotland: email <a href="mailto:healthandwellbeing@agescotland.org.uk">healthandwellbeing@agescotland.org.uk</a> or call on 0333 323 2400. Power Quiz provides four ready-made quizzes to get you started.  After that, you can have fun making up your own quizzes and use the My Quiz option to play the exercise videos for answers in each of your four rounds.</p>
        <h3>About Strength and Balance</h3>
        <p className="strengthAndBalance">Adults gradually lose bone density and muscle strength as they get older. However regular strength and balance exercise help to maintain bone density and muscles. These should be undertaken for at least ten minutes, three times a week, and every week. Public health guidance also recommends breaking up long periods of sitting and doing half an hour of moderate physical activity five days each week.</p>
        <div className="action">
          <Link className="button begin" to="/howtoplay">Next</Link>
        </div>
        <p className="misc"><i>Power Quiz® development and video demonstrations: Doug Anthoney and Rachel Connor | Music: Doug Anthoney © Age Scotland 2020 | Exercises consultancy Yolanda Strachan and Jenny Ackland | Age Scotland is grateful to the Armed Forces Covenant Fund Trust and Unforgotten Forces partnership for funding support for Power Quiz®</i></p>
      </div>
      <div className="header-footer">
        <img className="footer" src={require("../assets/header-footer-colours.jpg")} alt="Header" />
      </div>
    </div>
  );
}

export default About;
